export default __webpack_public_path__ + "static/media/thunb-2.7f88e7cd.jpg";